import { useTranslation } from "react-i18next";
import {
  MotifButton,
  MotifButtonGroup,
  MotifChip,
  MotifDropdown,
  MotifDropdownItem,
  MotifDropdownPortal,
  MotifFormField,
  MotifIcon,
} from "@ey-xd/motif-react";
import { IconoirMoreVert } from "@ey-xd/motif-icon";
import { useNavigate, useParams } from "react-router-dom";
import { SetStateAction, useCallback, useState } from "react";
import SearchInput from "@/components/SearchInput/SearchInput";
import { useLazyExportDocumentQuery } from "@/services/exports/exportsReducer";
import { commonFormateName, havingEditPermission } from "@/utility/common";
import { useSelector } from "react-redux";
import { CREATE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { IconoirNavArrowDown } from "@ey-xd/motif-icon";
import ClaimBulkImport from "@/features/claims/claimsTab/components/ClaimBulkImport";
import { useLazyDownloadTemplateDocumentQuery } from "@/services/manualDataSource/ManualDataSourceReducer";
interface TitleComplementProps {
  caseId: string;
  onSearch: (searchValue: string) => void;
  searchQuery: string;
  handleQuickSearchClear: () => void;
  isBasicSearch: boolean;
  handleClearBasicSearch: () => void;
  isBasicSearchApplied: boolean;
  setIsBasicSearchActive: (value: boolean) => void;
  isBasicSearchActive: boolean;
  creditorDetails?: any;
}

export default function TitleComplement({
  onSearch,
  caseId,
  handleQuickSearchClear,
  searchQuery,
  isBasicSearchApplied,
  isBasicSearchActive,
  setIsBasicSearchActive,
  creditorDetails,
}: TitleComplementProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { creditorId } = useParams();
  const { caseShortName, abbreviation } = useSelector(
    (state: any) => state.case
  );

  const [searchValue, setSearchValue] = useState(searchQuery);
  const permissions = useSelector((state: any) => state.permissions);
  const { Creditor, ImportJob, Claim } = permissions;
  const [showMenu, setShowMenu] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

  let creditorTitleMenu = [
    // "pages.creditors.creditorClaimTab.moreOptions.bulkUpload", // commented for later use
    // "pages.creditors.creditorClaimTab.moreOptions.bulkStatusUpdate",  // commented for later use
    {
      lable: "pages.creditors.creditorClaimTab.moreOptions.export",
      value: "export",
    },
  ];
  if (havingEditPermission(ImportJob) && havingEditPermission(Claim)  ) {
    creditorTitleMenu.push({
      lable: "pages.creditors.creditorClaimTab.moreOptions.bulkClaimImport",
      value: "bulkClaimImport",
    });
  }
  // if(havingEditPermission(Creditor)){
  // creditorTitleMenu.push({
  //   lable:"pages.creditors.creditorClaimTab.moreOptions.addNewClaim",
  //   value:"addNewClaim"
  // })
  // }
  const propData = {
    creditorId: creditorId || "",
    caseID: caseId || "",
  };
  const [templateDownloadError, setTemplateDownloadError] = useState<
    string | undefined
  >("");

  const [downloadDocument, { isLoading: templetDowmloadLoading }] =
    useLazyDownloadTemplateDocumentQuery();
  const handleDownloadBulkImportTemplate = async () => {
    try {
      await downloadDocument({
        url: "Claim/DownloadClaimTemplate",
        caseId,
        entityType: "2",
        fileName: caseShortName
          ? commonFormateName(
              caseShortName,
              "ClaimImportTemplate",
              abbreviation
            )
          : "",
      }).unwrap();
    } catch (error) {
      if (
        error &&
        typeof error === "object" &&
        "data" in error &&
        error?.data
      ) {
        const errObj = JSON.parse((error as any).data);
        return setTemplateDownloadError(errObj?.message || errObj?.title);
      } else setTemplateDownloadError("Something went wrong!!");
    }
  };
  const handleClose = () => {
    setShowBulkUploadModal(false);
    templateDownloadError && setTemplateDownloadError("");
  };
  const [exportDocument, { isLoading: exportLoading }] =
    useLazyExportDocumentQuery();
  const handleMenuClick = async (caseId: string, value: string) => {
    if (value === "export") {
      await exportDocument({
        caseId,
        creditorId,
        url: "/Creditor/ExportCreditorClaimsList",
        fileName: commonFormateName(
          caseShortName,
          "CreditorClaim",
          abbreviation
        ),
      });
    } else if (value === "bulkClaimImport") {
      setShowBulkUploadModal(true);
    } else {
      const navigationPaths: {
        [key: string]: { path: string; state?: object };
      } = {
        addNewClaim: {
          path: `/case/${caseId}/claim/claim-setup`,
          state: propData,
        },
      };

      const navigation = navigationPaths[value];
      if (navigation.state) {
        navigate(navigation.path, { state: navigation.state });
      } else {
        navigate(navigation.path);
      }
    }
  };

  const handleSearchChange = useCallback(
    (event: { target: { value: SetStateAction<string> } }) => {
      setSearchValue(event.target.value);
    },
    []
  );

  const handleOnSearch = useCallback(() => {
    onSearch(searchValue);
  }, [onSearch, searchValue]);

  if (!caseId) {
    return null;
  }

  return (
    <div className="motif-row creditor-claim-title-complement pad-r-10">
      {/* <MotifFormField> */}
      {!isBasicSearchActive && (
        <MotifFormField>
          <div>
            <SearchInput
              aria-label="Search"
              onChange={handleSearchChange}
              onClear={handleQuickSearchClear}
              onFocusShow={false}
              value={searchQuery}
              onEnter={handleOnSearch}
              placeholder={t("global.globalPlaceholder.quickSearchPlaceHolder")}
              withOutDebounce={true}
            />
          </div>
        </MotifFormField>
      )}
      {/* <MotifButtonGroup>
          <MotifButton
            variant="secondary"
            onClick={() => {
              dispatch(setShowBasicSeach(false));
            }}
          >
            {t("pages.claims.search.title")}
          </MotifButton>
          <MotifDropdownPortal
            open={showMenu}
            hideArrow={true}
            handleClickOutside={() => setShowMenu(false)}
            trigger={
              <MotifButton
                type="button"
                onClick={() => setShowMenu(!showMenu)}
                aria-label="Dropdown button"
                aria-haspopup="true"
                variant="secondary"
              >
                <MotifIcon
                  aria-label="Dropdown icon"
                  fill="none"
                  iconFunction={IconoirNavArrowDown}
                />
              </MotifButton>
            }
          >
            <MotifDropdownItem
              onClick={() => dispatch(setShowBasicSeach(true))}
            >
              {t("pages.claims.basicSearch.title")}
            </MotifDropdownItem>
            <MotifDropdownItem
              onClick={() => {
                dispatch(setShowBasicSeach(false));
              }}
            >
              {t("pages.claims.advancedSearch.title")}
            </MotifDropdownItem>
          </MotifDropdownPortal>
        </MotifButtonGroup> */}
      {!isBasicSearchActive && (
        <div
          style={{ height: "49px", marginTop: "7px" }}
          className="creditor-claim-search-group-container"
        >
          <MotifButtonGroup className={!isBasicSearchApplied ? "mar-r-20" : ""}>
            <MotifButton
              variant="secondary"
              onClick={() => {
                // dispatch(setShowBasicSeach(false));
              }}
            >
              {t("global.globalPlaceholder.searchTypesDropdown")}
            </MotifButton>
            <MotifDropdownPortal
              open={showMenu}
              hideArrow={true}
              handleClickOutside={() => setShowMenu(false)}
              trigger={
                <MotifButton
                  type="button"
                  onClick={() => setShowMenu(!showMenu)}
                  aria-label="Dropdown button"
                  aria-haspopup="true"
                  variant="secondary"
                >
                  <MotifIcon
                    aria-label="Dropdown icon"
                    fill="none"
                    iconFunction={IconoirNavArrowDown}
                  />
                </MotifButton>
              }
            >
              <MotifDropdownItem
                onClick={() => {
                  // dispatch(setShowBasicSeach(true));
                  // setShowAdvanceSearch(false);
                  setIsBasicSearchActive(true);
                }}
              >
                {t("pages.claims.basicSearch.title")}
              </MotifDropdownItem>
            </MotifDropdownPortal>
          </MotifButtonGroup>{" "}
        </div>
      )}
      {isBasicSearchApplied && (
        <MotifChip
          className="clear-search-chip"
          onClick={() => {
            handleQuickSearchClear();
          }}
          variant="monochrome-dark"
        >
          {t("pages.claims.basicSearch.clearSearch")}
        </MotifChip>
      )}
      <div className="motif-row" style={{ flexWrap: "nowrap" }}>
        {havingEditPermission(Creditor) && (
          <MotifButton
            style={{ height: "44px", justifySelf: "end" }}
            variant={CREATE_BUTTON_VARIANT}
            onClick={() => {
              navigate(
                `/case/${caseId}/claim/claim-setup?creditorId=${creditorId}&creditorName=${creditorDetails?.creditorName.replace(
                  / /g,
                  "_"
                )}`
              );
            }}
          >
            {t("pages.creditors.creditorClaimTab.moreOptions.addNewClaim")}
          </MotifButton>
        )}
        <div style={{ width: "2rem" }}>
          <MotifDropdown
            ariaLabelledby="dropdown-trigger-1"
            id="dropdown-1"
            trigger={
              <MotifButton
                aria-label="Fruits"
                id="dropdown-trigger-1"
                onClick={function Ga() {}}
                type="button"
                variant="text"
                style={{ marginTop: "5px" }}
                loading={exportLoading}
              >
                <MotifIcon iconFunction={IconoirMoreVert} />
              </MotifButton>
            }
          >
            <ul role="menu">
              {creditorTitleMenu.map((menuName) => {
                return (
                  <li role="menuitem">
                    <MotifDropdownItem
                      indexItem={1}
                      onClick={() => handleMenuClick(caseId, menuName.value)}
                    >
                      {t(menuName.lable)}
                    </MotifDropdownItem>
                  </li>
                );
              })}
            </ul>
          </MotifDropdown>
        </div>
      </div>
      {showBulkUploadModal && (
        <ClaimBulkImport
          showModal={true}
          setShowModal={setShowBulkUploadModal}
          title={t("pages.claims.claimsTable.bulkImport.title")}
          description={t("pages.claims.claimsTable.bulkImport.description")}
          onDownload={handleDownloadBulkImportTemplate}
          uploadLabel={t("pages.claims.claimsTable.bulkImport.uploadLabel")}
          uploadDescription={t(
            "pages.claims.claimsTable.bulkImport.uploadDescription"
          )}
          accept={t("pages.claims.claimsTable.bulkImport.accept")}
          maxFiles={1}
          onClose={handleClose}
          onBulkCreateSuccess={handleQuickSearchClear}
          templateDownloadError={templateDownloadError}
          templetDowmloadLoading={templetDowmloadLoading}
        />
      )}

      {/* </MotifFormField> */}
    </div>
  );
}
